<div class="fullcontainer">
  <div class='row titleContainer mb-3'>
    <div class="col">
      <h2 class='header' style='color: #006498'>Editing Lead: {{this.lead.subject}}</h2>
    </div>
  </div>

  <div class="content-block mb-3 p-3">
    <app-lead-form [lead]='this.lead'></app-lead-form>
  </div>

  <div class="row m-0">
    <div class="col content-block p-3">
      <span class='btn-group'>
        <button class='btn btn-success' (click)='save()'>Save</button>
        <button class='btn btn-danger' (click)='cancel()'>Cancel</button>
      </span>
    </div>
  </div>
</div>
